module.exports = __webpack_public_path__ + "img/cx3.ace98049.png";